export const APPLE = "apple";

const patterns = {
	[APPLE]: /(?:iPhone|iPad|Macintosh)/i,
};
Object.entries(patterns).forEach(([device, pattern]) => {
	if (pattern.test(window.navigator.userAgent)) {
		document.documentElement.classList.add(`is-${device}`);
	}
});

export function is(device) {
	return document.documentElement.classList.contains(`is-${device}`);
}
